<template>
    <div class="d-flex flex-column overflow-auto h-100">
        <div class="m-1 flex-grow-1 overflow-auto">
            <div class="flex-grow-1 overflow-auto" style="padding: 1.25rem">
                <div class="mb-3-rem" style="display: none">
                    <v-label>{{ $t("res_Label_From")}} *</v-label>
                    <v-text-field solo v-model='dispatchValues.fromEmail'></v-text-field>
                </div>
                <div class="mb-3-rem" v-if="this.transferId == 0">
                    <v-label>{{ $t("res_Label_Recipent")}} *</v-label>
                    <multi-select class="add-arrow" v-model="recipient" label="name" placeholder="Select" track-by="order" open-direction="bottom"
                        :options="recipients" :searchable="false" :internal-search="false" :clear-on-select="false"
                        :close-on-select="true" :options-limit="300" :max-height="600" :show-no-results="false"
                        :hide-selected="false" :multiple="false" ref="multiselect3">
                    </multi-select>
                </div>
                <div class="mb-3-rem">
                    <v-label>{{ $t("res_Label_To")}} *</v-label>
                    <div style="background-color: #eff2f5; border-radius: 8px;">
                        <div class="input-wrapper">
                        <div v-for="(tag, index) in toEmailTags" :key="index" class="chip">
                            {{ tag }}
                            <span class="close" @click="removeTag(index, 'TO')">×</span>
                        </div>

                        <v-text-field v-model="inputToEmails" @keydown.enter.prevent="addTag(inputToEmails, toEmailTags, 'TO')" solo flat dense :label="$t('res_Label_EnterEmailAddress')"
                            @keydown.tab.prevent="addTag(inputToEmails, toEmailTags, 'TO')" @keydown.backspace="handleBackspace"></v-text-field>
                        </div>
                    </div>
                </div>
                <div class="mb-3-rem">
                    <v-label>{{ $t("res_Label_CC")}}</v-label>
                    <div style="background-color: #eff2f5; border-radius: 8px;">
                        <div class="input-wrapper">
                        <div v-for="(tag, index) in ccEmailTags" :key="index" class="chip">
                            {{ tag }}
                            <span class="close" @click="removeTag(index, 'CC')">×</span>
                        </div>

                        <v-text-field v-model="inputCCEmails" @keydown.enter.prevent="addTag(inputCCEmails, ccEmailTags, 'CC')" solo flat dense :label="$t('res_Label_EnterEmailAddress')"
                            @keydown.tab.prevent="addTag(inputCCEmails, ccEmailTags, 'CC')" @keydown.backspace="handleBackspace"></v-text-field>
                        </div>
                    </div>
                </div>

                <div class="mb-3-rem">
                    <v-label>{{ $t("res_Label_Subject")}} *</v-label>
                    <v-text-field solo v-model='dispatchValues.subject'></v-text-field>
                </div>

                <div class="mb-3-rem" v-if="attachments.length !== 0">
                    <v-label>{{ $t("res_Label_Attachments")}}</v-label>
                    <v-list>
                        <v-list-item  v-for="(item, index) in attachments" :key="item.id">
                            <v-row align="center" no-gutters>
                                <v-col cols="7" class="d-flex align-center">
                                    <v-checkbox color="primary" v-model="dispatchValues.attachDocuments" :label="item.name" :value="item.id" hide-details class="ma-0 pa-0"></v-checkbox>
                                </v-col>
                                <v-col cols="5" class="d-flex align-center justify-end v-label theme--light">
                                    <span v-if="index === 0" class="me-4">({{ $t("res_Label_OriginalMail") }})</span>
                                    <span>{{ fileSizeInKB(item.fileSize) }} KB</span>
                                </v-col>
                            </v-row>
                        </v-list-item>
                    </v-list>
                </div>

                <div>
                    <v-label>{{ $t("res_Label_Body")}} *</v-label>
                    <McWysiwyg v-model="dispatchValues.body" :options="editorOptions" :key="trigger" v-if="dialogModelShow==true" />
                </div>
            </div>
        </div>
        
        <v-card-actions class="top-shadow gap-3">
            <v-btn class="light-blue flex-1" @click="closeDialog">{{ $t("res_ButtonText_Cancel")}}</v-btn>
            <v-btn class="primary flex-1" @click="sendDispatch">{{ $t("res_ButtonText_Dispatch")}}</v-btn>
        </v-card-actions>
    </div>
</template>

<script>
    import { McWysiwyg } from '@mycure/vue-wysiwyg'
    import constants from "@/assets/js/constants.js"
    import axios from "axios";
    import MultiSelect from 'vue-multiselect'
    import StructureUserSelector from '@/components/StructureUserSelector.vue'
    import * as utils from '@/assets/js/common.js'

    export default {
        name: 'EmailDispatchDocumentForm',
        components: { McWysiwyg, MultiSelect, StructureUserSelector },
        data: function () {
            return {
                constants: constants,
                toEmailTags: [],
                ccEmailTags: [],
                inputToEmails: "",
                inputCCEmails: "",
                loading: false,
                structureUsers: [],
                structureUsersCC: [],
                recipients: [
                    
                ],
                recipient: {},
                dispatchValues: {
                    fromEmail: '',
                    toEmails: [],
                    EmailCC: [],
                    subject: '',
                    recipient: '',
                    body: '',
                    attachDocuments: [],
                    template: '',
                    users: [],
                    recipients: [],
                    content: '',
                },
                trigger: 1,
                attachments: [],
                editorOptions: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'], // Basic font styles
                        [{ 'header': 1 }, { 'header': 2 }], // Headers
                        [{ 'list': 'ordered' }, { 'list': 'bullet' }], // Lists
                        ['link', 'image', 'video'], // Media
                        ['clean'] // Remove formatting
                    ],
                    formats: ['header', 'bold', 'italic', 'underline', 'strike', 'list', 'bullet', 'link', 'image', 'video', 'font'],
                    fontNames: ['Arial', 'Helvetica', 'Georgia', 'Times New Roman', 'Courier New'],
                    fontSize: ['10px', '12px', '14px', '16px', '18px', '24px', '36px']
                },
                utils: utils,
                isRealDispatch: false
            };
        },
        props: {
            documentSubject: { type: String, default: "" },
            documentId: { type: [String, Number], default: 0 },
            referenceNumber: { type: String, default: "" },
            transferId: { type: [String, Number], default: 0 },
            dialogModelShow: { type: Boolean, default: false },
            withAttachments: { type: Boolean, default: false},
            nodeId: { type: Number, default: 0 },
        },
        mounted ()
        { 
            this.clearData()
            this.initForm()
        },
        methods: 
        {
            addTag(inputEmails, emailTags, type) {
                const trimmed = inputEmails.trim();
                    if (trimmed && !emailTags.includes(trimmed)) {
                        var result = utils.validateEmail(trimmed)
                        if(result)
                            if(type == "CC")
                            {
                                this.ccEmailTags.push(trimmed);
                                this.inputCCEmails = "";
                            }
                            else
                            {
                                this.toEmailTags.push(trimmed);
                                this.inputToEmails = "";
                            }
                        else {
                            window.showAlert(this.$t("res_Msgs_InvalidEmail") + ` : ${trimmed}`, 'warning')
                            if(type == "CC")
                                this.inputCCEmails = "";
                            else
                                this.inputToEmails = "";
                        }
                    }
                    else {
                        if(type == "CC")
                            this.inputCCEmails = "";
                        else
                            this.inputToEmails = "";
                    }
            },
            removeTag(index, type) {
                if(type == "CC")
                    this.ccEmailTags.splice(index, 1);
                else
                    this.toEmailTags.splice(index, 1);
            },
            handleBackspace(type) {
                if (this.inputCCEmails === '' && this.ccEmailTags.length > 0 && type == "CC") {
                    this.removeTag(this.ccEmailTags.length - 1, 'CC');
                }
                else if (this.inputToEmails === '' && this.toEmailTags.length > 0 && type == "TO") {
                    this.removeTag(this.toEmailTags.length - 1, 'TO');
                }
            },
            fileSizeInKB(bytes) 
            {
                return (bytes / 1024).toFixed(2);
            },

            // Loads the recipients, the dispatch template and the attachments in a single request.
            getFormData()
            {
                this.dispatchValues.recipients = []
                this.recipients = []
                this.dispatchValues.attachDocuments = []

                if (this.documentId == null || this.documentId == "" || this.documentId == undefined)
                {
                    this.dispatchValues.body = "";
                    return;
                }

                window.showLoading();
                axios.get(constants.baseApiUrl + 'Template/GetDocumentEmailDispatchFormData?documentId=' + this.documentId
                    + '&transferId=' + this.transferId + '&nodeId=' + this.nodeId + '&withAttachments=' + this.withAttachments, { headers: constants.headers})
                    .then(res => {
                        var data = res.data || {};
                        this.setRecipients(data.recipients);
                        this.setTemplate(data.template);
                        if (this.withAttachments)
                        {
                            this.attachments = data.attachments || [];
                            this.dispatchValues.attachDocuments = this.attachments.map(element => element.id);
                        }
                    })
                    .catch(err => console.warn(err))
                    .finally(() => window.hideLoading())
            },
            setRecipients(recipients)
            {
                if(recipients != null && recipients.length > 0)
                {
                    this.recipients = recipients.map(element => ({
                        name: element.name,
                        id: element.id,
                        order: element.order,
                        defaultDesigatedPeronEmail: element.defaultDesigatedPeronEmail
                    }));

                    if(this.recipients.length == 1)
                        this.recipient = this.recipients[0];
                }
            },
            setTemplate(template)
            {
                if (template == null)
                    return;

                this.dispatchValues.body = template.body;
                this.dispatchValues.subject = template.subject;
            },
            openMultiSelectCtrl(id)
            {
                if (id === 1) this.$refs.multiselect1.activate()
                else if (id === 2) this.$refs.multiselect2.activate()
                else if (id === 3) this.$refs.multiselect3.activate()
            },
            initForm()
            {   
                var user = JSON.parse(sessionStorage.getItem("user"));
                this.dispatchValues.fromEmail = user.profile.Email;
                this.getFormData()
            },
            getUsers(query)
            {
                var methodUrl = 'StructureUser/search?showUsers=true&showInternalStructures=false&showExternalStructures=false&search=';
                axios.get(constants.baseApiUrl + methodUrl + query, { headers: constants.headers })
                    .then(res => 
                    {
                        this.dispatchValues.users = res.data
                    })
                    .catch(err => console.warn(err))
            },
            closeDialog() 
            {
                this.recipients = []
                this.recipient = null
                this.clearData();
                this.$emit('closeDialog')
            },
            getStructureUsers(query)
            {
                this.structureUsers = []
                var methodUrl = 'StructureUser/search?showUsers=true&showInternalStructures=false&showExternalStructures=false&search=';
                axios.get(constants.baseApiUrl + methodUrl + query, { headers: constants.headers })
                    .then(res => 
                    {
                        this.structureUsers = res.data
                        this.structureUsers.unshift({ id: Date.now(),name: query ,email: query });
                    })
                    .catch(err => console.warn(err))
            },
            getStructureUsersCC(query)
            {
                this.structureUsers = []
                var methodUrl = 'StructureUser/search?showUsers=true&showInternalStructures=false&showExternalStructures=false&search=';
                axios.get(constants.baseApiUrl + methodUrl + query, { headers: constants.headers })
                    .then(res => 
                    {
                        this.structureUsersCC = res.data
                        this.structureUsersCC.unshift({ id: Date.now(),name: query ,email: query });
                    })
                    .catch(err => console.warn(err))
            },
            sendDispatch: async function () 
            {   
                if (this.toEmailTags.length == 0 || this.dispatchValues.subject == "" || this.dispatchValues.body == "" || this.recipient.id == 0) 
                {
                    window.showAlert('res_Msgs_FillRequired', 'warning')
                }
                else
                {         
                    
                    window.showLoading();          
                    var methodUrl = 'Letter/AddDispatchLetter';

                    var updatedToEmails = [];
                    if (this.toEmailTags.length > 0)
                    {
                        var updatedToEmails = this.toEmailTags.map(x => x = {"email": x }); 
                    }

                    var updatedCCEmails = [];
                    if (this.ccEmailTags.length> 0)
                    {
                        updatedCCEmails = this.ccEmailTags.map(x => x = {"email": x });
                    }

                    const totalAttachmentsSize = this.attachments.reduce((acc, curr) => acc + curr.fileSize, 0);
                    if (totalAttachmentsSize > constants.maxDispatchAttachmentSizeInByteAttachments) { // 30MB
                        window.hideLoading();
                        window.showAlert('res_Msgs_AttachmentSizeExceeded', 'warning');
                        window.showAlert(window.translate("res_Msgs_AttachmentSizeExceeded") + constants.maxDispatchAttachmentSizeInMbAttachment, "warning");
                        return;
                    }

                    var dispatchBody = {
                        DocumentId: this.documentId,
                        FromEmail: this.dispatchValues.fromEmail,
                        ToEmail:updatedToEmails,
                        Ccemails: updatedCCEmails,
                        Subject: this.dispatchValues.subject,
                        Body: this.dispatchValues.body,
                        StorageAttachmentIds: this.dispatchValues.attachDocuments.join(', '),
                        isRealDispatch: this.isRealDispatch,
                        StructureId: this.recipient.id
                    }

                    axios.post(constants.baseApiUrl + methodUrl, dispatchBody, { headers: constants.headers })
                        .then(res => 
                        {
                            if(res.data != null && res.data == "Success")
                            {
                                window.hideLoading();
                                window.showAlert('res_Msgs_EmailDispatched', 'success')
                                this.closeDialog();
                            }
                            else
                            {
                                window.hideLoading();
                                window.showAlert('res_Msgs_Warning', 'warning')
                            }
                        })
                        .catch(err => console.warn(err))
                        .finally(() => window.hideLoading())
                }
            },
            GetDispatchedDocumentAttachment(query)
            {
                axios.get(constants.baseApiUrl + 'Document/GetDispatchedDocumentAttachment?structureId=' + query + '&documentId=' + this.documentId, { headers: constants.headers})
                    .then(res => {  
                        if(res.data != null && res.data != '')
                        {
                            // var body = this.dispatchValues.body.replace(/\d+\/\d+\/\d+/g, res.data.referenceNumber);
                            // this.dispatchValues.body = body;
                            this.attachments = [];
                            this.dispatchValues.attachDocuments = [];
                            const myArray = res.data.name.split("_");
                            let obj = {};
                            obj.id = res.data.id;
                            obj.extension = res.data.extension;
                            obj.fileSize = res.data.fileSize;  
                            if (this.documentSubject &&
                                this.documentSubject.trim() !== '') 
                            {
                                obj.name = this.documentSubject; 
                            } 
                            else 
                            {
                                obj.name = myArray[0];
                            } 
                            obj.size = myArray[1];
                            this.attachments.push(obj);
                            this.dispatchValues.attachDocuments.push(res.data.id);
                            this.isRealDispatch = true;

                            setTimeout(() => { this.trigger++; }, 500);
                        }
                    })
                    .catch(() => this.loading = false)
                    .finally(() => this.loading = false)
            },
            clearData: function () 
            {
                var user = JSON.parse(sessionStorage.getItem("user"));
                this.dispatchValues = {
                    fromEmail: user.profile.Email,
                    toEmails: [],
                    EmailCC: [],
                    subject: "",
                    recipient: "",
                    body: "",
                    attachDocuments: [],
                    template: "",
                    users: [],
                    recipients: [],
                    content: "",
                }
                this.toEmailTags = [],
                this.ccEmailTags = [],
                this.recipient={};
                this.attachments = [];
                this.inputToEmails = "";
                this.inputCCEmails =  "";
            }
        },
        watch: 
        {
            dialogModelShow(newVal, oldVal)
            {
                if (this.dialogModelShow) 
                {
                    this.clearData()
                    this.initForm()
                }
                else
                    this.clearData()
            },
            recipient(newVal, oldVal)
            {
                if(newVal != oldVal && newVal.name != null && newVal.name != undefined)
                {
                    const designatedEmail = newVal.defaultDesigatedPeronEmail;
                    if (designatedEmail && !this.toEmailTags.includes(designatedEmail)) {
                        this.addTag(designatedEmail, this.toEmailTags, 'TO');
                    }
                    else {
                        this.inputToEmails = "";
                        this.toEmailTags = []
                    }
                    //this.GetDispatchedDocumentAttachment(newVal.id)   
                }
            },
        },
    }
</script>

<style scoped>
    .v-icon.v-icon.v-icon--link {
        cursor: pointer;
        outline: none;
        left: 0% !important;
        position: relative !important;
    }
 
    .v-list-item:hover,
    .v-list-item[aria-expanded="true"] {
        color: #000 !important;
        background: #bfd1e447;
        border-radius: 6px;
    }

    .input-wrapper {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        border: 1px solid #ccc;
        padding-left: 6px;
        padding-right: 6px;
        border-radius: 8px;
    }

    .chip {
        background-color: #e0f0ff;
        padding: 4px 8px;
        margin: 2px;
        border-radius: 12px;
        display: flex;
        align-items: center;
    }

    .chip .close {
        margin-left: 6px;
        cursor: pointer;
    }

    input {
        padding-left: 6px;
        padding-right: 6px;
        min-width: 100px;
        flex: 1;
    }
</style>